export const VIEWER_ID = 'viewer';
